export const SET_CHECKMARK = 'SET_CHECKMARK';
export const CLEAR_CHECKMARK = 'CLEAR_CHECKMARK';
export const TOGGLE_NAVIGATION_VISIBILITY = 'TOGGLE_NAVIGATION_VISIBILITY';

export default SET_CHECKMARK;
